/* TypeScript file generated from I18n.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as I18nJS from './I18n.res.js';

export type locale = "en-EN" | "fr-FR";

export type currency = "EUR" | "USD" | "CNY";

export const locale: locale = I18nJS.locale as any;

export const t: (_1:string) => string = I18nJS.t as any;

export const isPlural: (_1:number) => boolean = I18nJS.isPlural as any;

export const template: <a>(_1:string, values:(undefined | a), _3:void) => string = I18nJS.template as any;

export const currencyEur: currency = I18nJS.currencyEur as any;

export const currencyUsd: currency = I18nJS.currencyUsd as any;

export const currencyCny: currency = I18nJS.currencyCny as any;
